import { ProvincesShortCode } from "../navigationTypes";
import { store } from "../../redux/store";
import { RPWDataReader, getDataReader } from "../../livedataFuncs";
import { runInnerFunction } from "../../compatManager";


namespace InFile {
    export function OneTimeCheck(
        province: ProvincesShortCode,
        _firmId: number,
        AppID: string,
        sid: string,
        _dataroot
    ) {
        getPortalId(province, sid, AppID).then((portalId) => {
            if (portalId !== -1) {
                const xmlPortalId = getPortalIdFromXML()
                if (!xmlPortalId) {
                    runInnerFunction('ReactShell.clientPortalUpdateId', { 'clientConnectId': portalId });
                }
            }
        })
        saveListProfile(AppID, sid)
    }

    function saveListProfile(AppID: string, sid: string)
    {
        let url = 'savelistprofile.asp?type=LastAccessedFiles&id='+AppID+'&SessionID='+sid;
        try{
            fetch(url);
        }
        catch(e) {
            console.error("Unable to add this file to the list of recently accessed files: ", e)
        }
        
    }
}

const getPortalIdFromXML = () => {
    let dataRoot = store?.getState()?.currentNavigation.livedataRootContainer.dataRoot;
    let DataReaderObj: RPWDataReader;
    DataReaderObj = getDataReader(dataRoot);
    return DataReaderObj.getClientConnectId();
}

const getPortalId = async (appProvinceShort: ProvincesShortCode, sid: string, appId: string) => {
    try {
        const url = `/clientportal/lawyer/${appProvinceShort}/portal?SessionID=${sid}&AppID=${appId}`
        const response = await fetch(url);
        const jsonResponse = JSON.parse(await response.text());
        if (jsonResponse.data && jsonResponse.data.length !== 0) {
            return jsonResponse.data[0].Id
        }
        return -1;
    } catch (e) {
        console.log('Unable to get Portal Id: ', e)
        return -1
    }
}

export default InFile;
